module.exports = __webpack_public_path__ + "static/media/talksCardBack.de3da806.svg";